import { _query } from './query.js'
import { isMobile } from './base-init.js'

export function onInputKey (e, button) {
  //See notes about 'which' and 'key'
  if (e.keyCode === 13) {
    // console.info(`false-- e.keyCode: ${e.keyCode}`)
    const target = _query(button)
    if (target !== null && isMobile) target.click()
    return false
  } else {
    // console.info(`true-- e.keyCode: ${e.keyCode}`)
    return true
  }
}

export default onInputKey
window.onInputKey = onInputKey